<template>
  <div>
    <!--
      博客文章搜索栏
      - 输入关键词后按回车或点击搜索图标，跳转到博客列表页并带上 keyword 查询参数
      - 在博客详情页侧边栏展示，方便用户快速搜索其他文章
    -->
    <base-text-field
      v-model="keyword"
      append-icon="mdi-magnify"
      :label="$t('blog.searchPlaceholder') || 'Search articles'"
      @click:append="doSearch"
      @keyup.enter="doSearch"
    />

    <base-info-card :title="$t('contact.title')">
      <base-img
        :src="require('@/assets/contact.jpg')"
        :alt="$t('contact.title')"
        class="mb-4"
        color="grey lighten-1"
        height="196"
        tile
        width="100%"
      />

      <base-body>
        {{ $t('contact.content1') }}
      </base-body>

      <v-btn
        class="mt-4"
        color="primary"
        depressed
        :to="{ name: 'Contact', params: { lang: $i18n.locale } }"
      >
        {{ $t('contact.title') }}
      </v-btn>
    </base-info-card>
  </div>
</template>

<script>
  export default {
    name: 'NewsSearch',

    data () {
      return {
        keyword: '',
      }
    },

    methods: {
      /**
       * 执行搜索：跳转到博客列表页，将关键词作为 query 参数传递
       * BlogList 组件会读取 route.query.keyword 来筛选文章
       */
      doSearch () {
        const kw = (this.keyword || '').trim()
        if (!kw) return
        this.$router.push({
          name: 'Blog',
          params: { lang: this.$i18n.locale },
          query: { keyword: kw },
        })
      },
    },
  }
</script>
